<template>
  <div class="row">
    <div class="col-md-12">
      <reward-form @on-submit="onRewardSubmit"></reward-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import RewardForm from './RewardProgramForm.vue'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      RewardForm
    },
    data () {
      return {
        couponModel: {},
        coupon: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onRewardSubmit (model, isValid) {
        this.offerModel = model
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/RewardProgram/RewardProgramEdit.vue